import React from 'react';
import { useQuery } from 'react-query';
import { FiPlus, FiEdit, FiTrash2 } from 'react-icons/fi';
import { classesService } from '../services/api';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import ClasseModal from '../components/ClasseModal';
import { useAuth } from '../contexts/AuthContext';
import ConditionalButton from '../components/common/ConditionalButton';
import ConditionalActions from '../components/common/ConditionalActions';

const Classes = () => {
 // const { user: _user } = useAuth(); // Préfixe _ pour indiquer variable intentionnellement inutilisée
  const { data: classes, isLoading, refetch } = useQuery(
    'classes',
    () => classesService.getAll(),
    {
      onError: (error) => {
        toast.error('Erreur lors du chargement des classes');
      }
    }
  );

const handleDelete = async (id) => {
  const result = await Swal.fire({
    title: 'Supprimer cette classe ?',
    text: 'Cette action est irréversible.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Oui, supprimer',
    cancelButtonText: 'Annuler',
  });
  if (result.isConfirmed) {
    try {
      await classesService.delete(id);
      toast.success('Classe supprimée avec succès');
      refetch();
      Swal.fire('Supprimé !', 'La classe a été supprimée.', 'success');
    } catch (error) {
      toast.error('Erreur lors de la suppression');
    }
  }
};
const [editing, setEditing] = React.useState(null);
const [showModal, setShowModal] = React.useState(false);
const handleEdit = (classe) => {
  setEditing(classe);
  setShowModal(true);
};
  
  

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Classes</h1>
        <ConditionalButton
          entity="classes"
          permission="create"
          onClick={() => { setEditing(null); setShowModal(true); }}
          className="flex items-center space-x-2 bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700"
        >
          <FiPlus />
          <span>Nouvelle classe</span>
        </ConditionalButton>
      </div>

      {/* Table */}
      <div className="bg-white shadow rounded-lg overflow-hidden">
        {isLoading ? (
          <div className="p-8 text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
          </div>
        ) : (
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Classe
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Abréviation
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Cycle
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  N° d'ordre
                </th>
                <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {Array.isArray(classes?.data) && classes.data.length === 0 ? (
                <tr>
                  <td colSpan="5" className="px-6 py-4 text-center text-gray-500">
                    Aucune classe trouvée
                  </td>
                </tr>
              ) : (
                (Array.isArray(classes?.data.data) ? classes.data.data : []).map((classe) => (
                  <tr key={classe.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                      {classe.classe}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {classe.abrev}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {classe.cycle}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      {classe.num_ordre}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <ConditionalActions
                        entity="classes"
                        onEdit={() => handleEdit(classe)}
                        onDelete={() => handleDelete(classe.id)}
                        editIcon={FiEdit}
                        deleteIcon={FiTrash2}
                        className="flex space-x-2"
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
      {showModal && (
        <ClasseModal
          show={showModal}
          onClose={() => setShowModal(false)}
          editing={editing}
          refetch={refetch}
        />
      )}
    </div>
  );
};

export default Classes;